import {env} from "../../../../../res/config/env";
import SolrPromotion from "../../../../logic/search/solrPromotion";
import HttpClient from "../../../http/HttpClient";

const processResponse = (res) => {
    const solrResponse = res.data.response;
    const promotions = solrResponse.docs.map(SolrPromotion.formatPromotion);
    const count = solrResponse.numFound;
    const start = solrResponse.start;
    return {
        promotions,
        count,
        start
    }
}

const solrMultiBuyRequest = () => {

    const builder = {};
    const params = { };

    builder.productIDs = (...productIDs) => {
        params.productIDs = productIDs;
        return builder;
    }

    const buildRequestUrl = (params) => {
        const url = env.API_SOLR_URL;
        const select = "select?q=(Table_Name:M_Promotion)"
        const pidFilters = !params.productIDs || params.productIDs.length <= 0 ? "" :
            "AND(" + (params.productIDs.map(pid => `(productIDs:${pid})`)).join("OR") + ")";
        const rows = "&rows=100"

        return url + select + pidFilters + rows;
    }

    builder.sendRequest = async () => {
        const url = buildRequestUrl(params);
        const res = await HttpClient.client.get(url);
        return processResponse(res);
    }

    return builder;
}

export default solrMultiBuyRequest;
